import ResourceStore from "../../../shared/services/ResourceStore";

class VoucherTemplateStore extends ResourceStore {
  _baseUrl (_params) {
    return `/api/v4/companies/${_params.companyId}`;
  }

  async rankObject (e, objectClass) {
    let data = new FormData();
    e.forEach(function (element) {
      data.append(`${objectClass}[]`, element.id);
    });

    let response = await fetch(
      "/api/v4/rank", {
        body: data,
        method: "PATCH"
      }
    );

    return response.json();
  }

  async fetchByVoucherType (companyId, voucherType) {
    let response = await fetch(
      `/api/v4/companies/${companyId}/voucher_templates?filter[voucher_type]=${voucherType}`
    );

    const responseJSON = await response.json();

    return responseJSON;
  }
};

export default new VoucherTemplateStore("voucher_template");
